export class FormFieldValidator {
    constructor(props) {
    }

    validate(value) {}
}

export const notEmptyValidator = (value) => {
    return (
        value !== null &&
        value !== undefined &&
        value !== '' &&
        (!Array.isArray(value) || value.length > 0) &&
        (typeof value !== 'object' || Object.keys(value).length > 0)
    );
};

export const trueValidator = (value) => {
    return value === true;
};

export const emailValidator = (value) => {
    return [
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        /^((?!mark@gmail\.com).)*$/
    ].every((regExp) => regExp.test(value));
}